declare var Razorpay: any;

import { Component, NgZone, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { RazorpayService } from 'src/app/services/razorpay.service';
import { SubscriptionService } from 'src/app/services/subscription.service';
import { UsersService } from 'src/app/services/users.service';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})

export class PricingComponent implements OnInit {
  errorMessage: string;
  subscriptionPlans: any[];
  selectedPlan: any;
  user: any;
  isProUser: boolean;


  /* Loading and spinner related flags. */
  isVerifyingPayment = false;
  isCreatingSubscription = false;
  loadingPlanId: string = null;


  constructor(
    private toastrService: ToastrService,
    private subscriptionService: SubscriptionService,
    private razorpayLoader: RazorpayService,
    private router: Router,
    private userService: UsersService,
    private ngZone: NgZone
  ) { }

  allFeatures: string[] = [];
  ngOnInit(): void {
    this.subscriptionService.getAllCatalogPlans().subscribe((res: any) => {
      this.subscriptionPlans = _.sortBy(res.data.plans, p => p.item.amount);      // Compute unique features across all plans for table rows
      this.allFeatures = _.uniq(_.flatten(this.subscriptionPlans.map(p => p.notes))).filter(f => !/\bno\b/i.test(f));
    })

    const user = JSON.parse(sessionStorage.getItem('logged-in-user'));
    if (_.isEmpty(user))
      return;

    const userId = user._id;
    this.userService.getUserDetails(userId).subscribe(res => {
      this.user = res;
      this.isProUser = _.get(this.user, 'subscription.subscriptionType') == 'PRO';
    })
  }

  onSelectPlan(plan) {
    this.selectedPlan = plan;
  }

  assembleCreateSubscriptionPayload(plan) {
    const userInfo = JSON.parse(sessionStorage.getItem('logged-in-user'));
    return {
      user_info: {
        user_id: userInfo._id,
        email: userInfo.email
      },
      plan_id: plan._id
    }
  }

  verifyPayment(response: any) {
    const loggedInUser = sessionStorage.getItem('logged-in-user');
    const userInfo = JSON.parse(loggedInUser);
    this.isVerifyingPayment = true;


    const payload = {
      razorpay_payment_id: response.razorpay_payment_id,
      razorpay_subscription_id: response.razorpay_subscription_id,
      razorpay_signature: response.razorpay_signature
    }
    this.subscriptionService.verifySubscriptionPayment(payload).subscribe(async (res: any) => {
      this.toastrService.success('Your payment was initated successfully');

      /* To immediately update localStorage cache with PRO user details. */
      setTimeout(async () => {
        const user = await this.userService.getUserDetails(userInfo._id).toPromise();
        sessionStorage.setItem('logged-in-user', JSON.stringify(user));
        this.ngZone.run(() => {
          this.isVerifyingPayment = false;
          this.loadingPlanId = null;

          this.router.navigate([`student/${userInfo._id}/dashboard`]);
        });
      }, 5000);

    }, ({ error }) => {
      this.isVerifyingPayment = false;
      this.toastrService.error(error.message);
    })
  }

  async openCheckout(subscriptionId: string) {
    await this.razorpayLoader.loadRazorpay();

    const options = {
      key: environment.RAZORPAY_KEY_ID,
      subscription_id: subscriptionId,
      name: 'The Laboratory Matters',
      description: this.selectedPlan.name,

      handler: (response: any) => {
        this.verifyPayment(response);
      },

      modal: {
        ondismiss: () => {
          this.errorMessage = 'Payment popup closed';
        }
      },

      theme: {
        color: '#3399cc'
      }
    };

    const rzp = new Razorpay(options);
    rzp.open();
  }



  onPayNowClick(plan: any): void {
    this.selectedPlan = plan;
    if (!this.user) {
      this.toastrService.error('Please login to continue');
      return;
    }

    if (this.isProUser) {
      this.toastrService.success('You are already a PRO user');
      return;
    }

    if (!this.selectedPlan) {
      this.toastrService.error('Please select a plan');
      return;
    }

    /* Loading spinner related logic. */
    this.isCreatingSubscription = true;
    this.loadingPlanId = plan._id;

    const payload = this.assembleCreateSubscriptionPayload(this.selectedPlan);
    this.subscriptionService.createSubscription(payload).subscribe((res) => {
      this.isCreatingSubscription = false;
      const razorpaySubscriptionId = _.get(res, 'data.data.subscriptionRecord.razorpay_subscription_id');
      console.log({ razorpaySubscriptionId });
      this.openCheckout(razorpaySubscriptionId);
    }, ({ error }) => {
      this.isCreatingSubscription = false;
      this.loadingPlanId = null;
      this.toastrService.error(error.message);
    })
  }
}
